<template>
  <DealTag
    v-if="dealTag"
    :icon="dealTag.icon"
    :label="dealTag.label"
    :tooltip-text="dealTag.tooltipText"
  />
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import DealTag from './Deal/components/DealTag.vue'

defineProps<{
  dealTag?: {
    label: string
    icon: Component
    tooltipText?: string
  }
}>()
</script>
